import React from "react";
import { AdminCertifiedModeEditLoaderTemplate } from "themes/administration/certified-mode/components";

function AdminCertifiedModeEditLoader(props) {
    return <AdminCertifiedModeEditLoaderTemplate {...props} />;
}

export default AdminCertifiedModeEditLoader;
